module.exports = __webpack_public_path__ + "img/854.0adbd96d.png";